import 'css-chunk:../authentication/frontend/components/log-in-with-onshape/index.module.scss';export default {
  "logo": "_logo_i0r6h_1"
};